import { Container, Typography } from '@mui/material';
import Markdown, { type MarkdownToJSX } from 'markdown-to-jsx';
import React, { useEffect, useState } from 'react';

import Documentation from '../../api/documentation';
import { markdownOptions } from '../../helpers/markdownOptions';
import useApiQuery from '../../hooks/useApiQuery';

interface WhatsNewContent {
  title: string;
  content: string;
}

const WhatsNew = (): React.JSX.Element | null => {
  const [content, setContent] = useState<WhatsNewContent | null>(null);
  const { makeApiCall: getWhatsNewCall } = useApiQuery<WhatsNewContent>(
    Documentation.getWhatsNew.bind(Documentation) as (...args: unknown[]) => Promise<WhatsNewContent | { data?: WhatsNewContent }>
  );

  useEffect(() => {
    const fetchWhatsNew = async (): Promise<void> => {
      const data: WhatsNewContent | null = await getWhatsNewCall();
      if (data) setContent(data);
    };

    fetchWhatsNew();
  }, [getWhatsNewCall]);

  return content ? (
    <Container sx={{ mt: 4, mb: 4 }}>
      <Typography
        variant='h3'
        gutterBottom
        sx={{ fontWeight: 'bold', mb: 3 }}
      >
        {content.title}
      </Typography>
      <Markdown options={markdownOptions as MarkdownToJSX.Options}>{content.content}</Markdown>
    </Container>
  ) : null;
};

export default WhatsNew;
